//
//
//
//
//
//
//
//
//

import passageFansManager from "@/Manager/01.Wechat/PassageFansUserManager";
import businessUnitManager from "@/Manager/09.Cm/BusinessUnitManager";
import CheckCode from "@/components/common2/comBindUserCheckCode";
import passageUserManager from "@/Manager/09.Cm/PassageUserManager";
export default {
    components: {
        "check-code": CheckCode
    },
    data() {
        return {
            BusinessUnitItem: {},
            PassageUserFansItem: {},
            BindItem: {
                Mobile: "",
                SmsCheckCode: "",
                Message: "您的微信账号将与雅士利国际服务号绑定,成为我们的门店管理员,参与更多经销商工作"
            },
            dataInfo: {}
        };
    },
    async created() {
        this.BusinessUnitItem = await businessUnitManager.getSessionBusinessUnit();
        var result = passageFansManager.checkPassageFansUser();
        if(result == 302){
            return;
        }
        var fans = result;
        this.PassageUserFansItem = await passageFansManager.asyncLoadPassageUserFans(this);
        fans = this.$appBox.getPassageUserFans();
    },
    methods: {
        startBind(mobile, smsCheckCode) {
            this.$msg.loading();
            var bindItem = this.BindItem;
            this.$http({
                method: "post",
                url: this.$api.DoBindWechat,
                data: {
                    mobile: mobile,
                    smsCheckCode: smsCheckCode
                }
            }).then(res => {
                // this.dataInfo = res.data;
                this.$msg.hideLoading();
                if (res.data.state == 1) {
                    this.$msg.succ("绑定成功");
                    passageUserManager.setSessionPassageUser(res.data.data);
                    var url = "/Sms?uOpenId=" + this.BusinessUnitItem.OpenId;
                    this.$router.push({
                        path: url,
                    });
                } else {
                    this.$msg.fail(res.data.msg);
                    window.scrollTo(0, 0);
                }
            });
        }
    }
};
